import React, { useState } from 'react'
import DataTable from '../../../components/datatable'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import { useHistory } from 'react-router-dom'
import {
  useDeleteAnnouncement,
  useGetScheduledAnnouncements,
  usePublishAnnouncement,
} from '../../../redux/employees/hook/announcement'
import SendAnnouncement from '../dashboard/SendAnnouncement'

const ScheduledAnnouncements = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })
  const history = useHistory()

  const { mutateAsync: deleteAnnouncement } = useDeleteAnnouncement()
  const { mutateAsync: publishAnnouncement } = usePublishAnnouncement()
  const [announcement, setAnnouncement] = useState(false)
  const [announcementData, setAnnouncementData] = useState(null)

  const { data: announcements } = useGetScheduledAnnouncements(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Announcement Title', 'Audience', 'Scheduled Published Date'],
    keys: ['title', 'audience', 'publish_date'],
    mobileHeader: {
      left: {
        title: 'Announcement Title',
        key: 'title',
      },
      right: {
        title: 'Audience',
        key: 'audience',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
        history.push('/announcements/view/' + announcements.data[index].id)
      },
    },
    {
      name: 'Publish',
      color: 'orange',
      action: async (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
        await publishAnnouncement({ id: announcements.data[index].id })
      },
    },
    {
      name: 'Update',
      color: 'blue',
      action: async (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
                setAnnouncementData(announcements.data[index])

        setAnnouncement(true)
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: async (id) => {
        let index = announcements.data.findIndex((item) => item.id === id)
        await deleteAnnouncement(announcements.data[index].id)
      },
    },
  ]
  return (
    <div>
      {announcement && (
        <SendAnnouncement
          isOpen={announcement}
          closeModal={() => setAnnouncement(false)}
          announcementData={announcementData}
        />
      )}
      <DataTable
        data={announcements}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        searchData={true}
        noCheck
      />
    </div>
  )
}

export default ScheduledAnnouncements
